<template>
  <div :class="extensionClass">
    <span class="number">{{ extension }}</span
    ><span class="dot"></span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PhoneExtension",
  props: {
    extension: String,
    state: String,
    call: Boolean,
  },
  computed: {
    ...mapGetters("clientUserRegisterData", ["deskNumber"]),

    extensionClass() {
      const classes = ["extension"];
      if (this.state === "online") {
        this.call ? classes.push("danger") : classes.push("success");
      } else {
        classes.push("info");
      }
      if (this.extension === this.deskNumber) {
        classes.push("current");
      }
      return classes;
    },

    current() {
      return this.extension === this.deskNumber;
    },
  },
};
</script>

<style lang="scss" scoped>
.current {
  font-weight: bold;
}

.extension {
  display: flex;
  color: white !important;
  font-size: 10px;
  border-radius: 10px;
  position: relative;
  margin: 2px 1px;
  justify-content: center;
  align-items: center;

  .dot {
    width: 6px;
    height: 6px;
    display: block;
    border-radius: 10px;
    background-color: red;
    margin-left: 2px;
  }

  .number {
    padding-top: 1px;
  }

  &.info {
    .dot {
      background-color: #7992a4;
    }
  }

  &.success {
    .dot {
      background-color: #30b08f;
    }
  }

  &.danger {
    .dot {
      background-color: #c03639;
    }
  }
}
</style>
